import List from "./service-account-list"
import Form from "./service-account-form"
import View from "./service-account-view"

const ServiceAccount = { List, Form, View }

export default ServiceAccount
